import { formatTime } from './format-time.js'

export function makeColumnDefsErrors () {
  return [
    {
      headerName: 'Module',
      field: 'module'
    },
    {
      headerName: 'Error',
      field: 'error'
    },
    {
      headerName: 'Created At',
      valueGetter: function (cellParams) {
        return cellParams.data.created_at
      },
      valueFormatter: function (cellParams) {
        return formatTime(cellParams.value)
      }
    },
    {
      headerName: 'Error Constructor Name',
      field: 'error_constructor_name'
    },
    {
      headerName: 'Error Message',
      field: 'error_message'
    },
    {
      headerName: 'Error Name',
      field: 'error_name'
    },
    {
      headerName: 'Error Properties',
      field: 'error_properties'
    },
    {
      headerName: 'Error Trigger',
      field: 'error_trigger'
    },
    {
      headerName: 'Stack',
      field: 'stack'
    },
    {
      headerName: 'Other',
      field: 'other'
    }
  ]
}
